const gayaHidup: any = {
	'diet-nutrisi': {
		title: 'Informasi Diet & Nutrisi Terlengkap',
		description:
			'Informasi seputar diet, kebutuhan nutrisi dalam tubuh, kandungan gizi makanan, ' +
			'resep makanan sehat, dan panduan memilih vitamin hanya di KlikDokter.',
	},
	'sehat-bugar': {
		title: 'Informasi Sehat & Bugar Terlengkap',
		description:
			'Informasi seputar langkah-langkah menerapkan pola hidup sehat termasuk tips ' +
			'kebugaran, olahraga, hingga travelling.',
	},
	'perawatan-wanita': {
		title: 'Informasi Perawatan Wanita',
		description:
			'Informasi seputar pembahasan mengenai cara merawat organ intim (vagina dan payudara) ' +
			'dan tubuh wanita hanya di KlikDokter.',
	},
	'perawatan-pria': {
		title: 'Informasi Perawatan Pria',
		description:
			'Informasi seputar pembahasan mengenai perawatan kesehatan organ intim pada ' +
			'tubuh pria hanya di KlikDokter.',
	},
	seks: {
		title: 'Informasi Seputar Seks Terlengkap',
		description:
			'Informasi seputar pembahasan mengenai seks mulai dari tips berhubungan Intim, ' +
			'masalah dan gangguan seksual, hingga kontrasepsi hanya di KlikDokter.',
	},
};

export default gayaHidup;
